import React, { Component } from "react";
import {
  Container,
  Header,
  Grid,
  Button,
  Table,
  Image
} from "semantic-ui-react";
import { app } from "../../index";
import estimatePDFDownload from "../pdf/estimatePDFDownload";

class Estimator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "",
      program: "",
      won: "",
      tasks: [],
      title: "",
      deliverables: [],
      sownum: "",
      tjanum: "",
      date: "",
      writtenfor: "",
      writtenby: "",
      poitem: "",
      docs: ""
    };
  }
  componentWillMount() {
    app
      .service("estimates")
      .get(this.props.params.estimatenumber)
      .then(estimate => {
        this.setState({
          program: estimate.program,
          won: estimate.workOrderNbr,
          scope: estimate.scopeOfWorkSummary,
          tjanum: estimate.tjaNbr,
          sownum: estimate.sowNumber,
          title: estimate.description,
          tasks: JSON.parse(estimate.tasks),
          deliverables: JSON.parse(estimate.deliverables),
          date: estimate.createDate,
          docs: estimate.standardWork,
          estimate
        });
        this.getstuff(estimate.projmanager, estimate.creator);
      });
  }
  getstuff(pm, creator) {
    console.log(pm, creator);
    let pmservice = app.service("engassigned");
    let empservice = app.service("edfemployees");
    var writtenFor;
    var writtenBy;
    pmservice
      .get(pm)
      .then(pm => {
        writtenFor = pm.contactname;
      })
      .then(() => {
        empservice
          .get(creator)
          .then(emp => {
            writtenBy = emp.firstname + " " + emp.lastname;
          })
          .then(() =>
            this.setState({ writtenfor: writtenFor, writtenby: writtenBy })
          );
      });
  }
  gentask() {
    console.log(this.state.tasks);
    return this.state.tasks.map(task => {
      let subtotal = task.rate * task.hours;
      return (
        <Table.Row>
          <Table.Cell width={1}>{task.item}</Table.Cell>
          <Table.Cell width={6}>{task.description}</Table.Cell>
          <Table.Cell width={1}>{task.hours}</Table.Cell>
          <Table.Cell width={1}>${task.rate}</Table.Cell>
          <Table.Cell width={1}>${subtotal.toFixed(2)}</Table.Cell>
        </Table.Row>
      );
    });
  }

  gendeliv() {
    return this.state.deliverables.map(deliv => {
      let datereq = "No";
      if (deliv.dateRequired === true) {
        datereq = "Yes";
      }
      return (
        <Table.Row>
          <Table.Cell width={1}>{deliv.item}</Table.Cell>
          <Table.Cell width={6}>{deliv.description}</Table.Cell>
          <Table.Cell width={1}>{deliv.date}</Table.Cell>
          <Table.Cell width={1}>{datereq}</Table.Cell>
        </Table.Row>
      );
    });
  }

  gentotalhours() {
    var totalhours = 0;

    for (let task of this.state.tasks) {
      let taskhours = parseFloat(task.hours);
      totalhours = taskhours + totalhours;
    }

    return totalhours;
  }
  gensubtotal() {
    var totalmoney = 0;

    for (let task of this.state.tasks) {
      let money = task.hours * task.rate;
      totalmoney = totalmoney + money;
    }

    return totalmoney.toFixed(2);
  }
  gentasktable() {
    if (this.state.tasks.length !== 0) {
      return (
        <Table celled structured compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="5">Tasks</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell width={1}>Task #</Table.HeaderCell>
              <Table.HeaderCell width={6}>Task Description</Table.HeaderCell>
              <Table.HeaderCell width={1}>Hours</Table.HeaderCell>
              <Table.HeaderCell width={1}>Rate</Table.HeaderCell>
              <Table.HeaderCell width={1}>Subtotal</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>{this.gentask()}</Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="2" />
              <Table.HeaderCell>{this.gentotalhours()}</Table.HeaderCell>
              <Table.HeaderCell>Total:</Table.HeaderCell>
              <Table.HeaderCell>${this.gensubtotal()}</Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      );
    }
  }
  gendelivtable() {
    if (this.state.deliverables.length > 0) {
      return (
        <Table celled structured compact>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan="4">Deliverables</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell singleLine width={1}>
                Deliverable #
              </Table.HeaderCell>
              <Table.HeaderCell width={6}>
                Deliverable Description
              </Table.HeaderCell>
              <Table.HeaderCell width={1}>Date</Table.HeaderCell>
              <Table.HeaderCell width={1}>Date Required</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body celled>{this.gendeliv()}</Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="4" />
            </Table.Row>
          </Table.Footer>
        </Table>
      );
    }
  }

  gendeliv() {
    if (this.state.deliverables.length > 0) {
      return this.state.deliverables.map(deliv => {
        let datereq = "No";
        if (deliv.dateRequired === 1) {
          datereq = "Yes";
        }
        return (
          <Table.Row>
            <Table.Cell width={1}>{deliv.item}</Table.Cell>
            <Table.Cell width={6}>{deliv.description}</Table.Cell>
            <Table.Cell width={1}>{deliv.date}</Table.Cell>
            <Table.Cell width={1}>{datereq}</Table.Cell>
          </Table.Row>
        );
      });
    }
  }
  genprintBtn() {
    return (
      <Button onClick={() => estimatePDFDownload(this.state.estimate)}>
        Print
      </Button>
    );
  }
  render() {
    return (
      <div>
        <Grid>
          <Grid.Row centered>
            <Image src={require("./custPrintLetterhead.png")} centered />
          </Grid.Row>
          <Grid.Row centered>
            <h3>Statement of Work</h3>
          </Grid.Row>
          <Grid.Row centered>
            <Grid.Column mobile={16} tablet={14} computer={10}>
              <Container>
                <Table structured compact>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell width={1} inline singleLine>
                        Written For:
                      </Table.Cell>
                      <Table.Cell width={6} textAlign="left">
                        {this.state.writtenfor}
                      </Table.Cell>
                      <Table.Cell width={1}>Status:</Table.Cell>
                      <Table.Cell textAlign="left" width={6}>
                        {this.state.status}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={1} inline>
                        By:
                      </Table.Cell>
                      <Table.Cell width={6} textAlign="left">
                        {this.state.writtenby}
                      </Table.Cell>
                      <Table.Cell width={1}>Title:</Table.Cell>
                      <Table.Cell textAlign="left" width={6}>
                        {this.state.title}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={1} inline>
                        Date:
                      </Table.Cell>
                      <Table.Cell width={6} textAlign="left">
                        {this.state.date}
                      </Table.Cell>
                      <Table.Cell width={1}>SoW #:</Table.Cell>
                      <Table.Cell textAlign="left" width={6}>
                        {this.state.sownum}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={1} inline>
                        EDF #:
                      </Table.Cell>
                      <Table.Cell width={6} textAlign="left">
                        {this.state.won}
                      </Table.Cell>
                      <Table.Cell width={1}>PO #:</Table.Cell>
                      <Table.Cell textAlign="left" width={6}>
                        {this.state.ponum}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell width={1} inline>
                        Project:
                      </Table.Cell>
                      <Table.Cell width={6} textAlign="left">
                        {this.state.program}
                      </Table.Cell>
                      <Table.Cell singleLine width={1}>
                        PO Item:
                      </Table.Cell>
                      <Table.Cell textAlign="left" width={6}>
                        {this.state.poitem}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
                <Header as="h5">Scope of Work:</Header>
                <Container>
                  <p>{this.state.scope}</p>
                </Container>
                <Header as="h5">Standard Work Documents:</Header>
                <Container>
                  <p>{this.state.docs}</p>
                </Container>
                {this.gentasktable()}
                {this.gendelivtable()}
              </Container>
            </Grid.Column>
            {this.genprintBtn()}
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}
export default Estimator;



// WEBPACK FOOTER //
// ./src/components/estimates/estimateview.js